exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n.wrapper {\n  font-size: 0.37333333rem;\n}\n.router_view.blur {\n  filter: blur(0.13333333rem);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-61a668f8!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app.vue
// module id = 316
// module chunks = 1